import React from 'react';
import cls from '@utils/css-select'
import styles from './styles.scss'
import ModuleTitle from 'pages/offical/faq/components/module-title/main';
import List from '../list/main'
import { useTranslation } from 'hooks/use-translation';
const cx = cls(styles)

function Technical(props: { className?: string }) {
	const { transData } = useTranslation('faq')
	const { title1, technicalSupport } = transData
	return (
		<div className={cx(props.className)}>
			<ModuleTitle>
				{title1}
			</ModuleTitle>
			<List listData={technicalSupport} transData={transData} />
		</div>
	)
}

export default Technical
